var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { UtilitiesContext, Loader, DotsLoader, Well, Icon, Row, Col, FadeSection } from "@brushfire/ui";
import { getEventList } from "../../../data/api";
import { debounce, pick } from "lodash";
import moment from "moment";
import Constants from "../../../data/constants";
import * as qs from "query-string";
import { setInlineError } from "../../../store/AppState/actions";
import InlineError from "../../UI/InlineError";
import { handleErrors } from "../../../data/helpers";
import useWidgetAnalytics from "../../../hooks/useWidgetAnalytics";
import { getLocal, LOCAL_STORAGE_KEYS, setLocal } from "../../../data/localStorageHelpers";
import { WidgetContext } from "../../Widget";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { differenceInCalendarDays } from "date-fns";
import CalendarEvents from "./CalendarEvents";
import RegisterFooter from "../Register/RegisterFooter";
import CalendarDate from "./CalendarDate";
import { useSpecificBFPayment } from "../../../hooks/useSpecificBFPayment";
var useTypedSelector = useSelector;
var CalendarView = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var theme = _a.theme, isWidget = _a.isWidget;
    var _x = __read(useState(false), 2), isLoaded = _x[0], setIsLoaded = _x[1];
    var _y = __read(useState(true), 2), isFetchingCalendar = _y[0], setIsFetchingCalendar = _y[1];
    var _z = __read(useState(), 2), headScripts = _z[0], setHeadScripts = _z[1];
    var _0 = __read(useState(), 2), bodyScripts = _0[0], setBodyScripts = _0[1];
    var _1 = __read(useState(), 2), initialValues = _1[0], setInitialValues = _1[1];
    var _2 = __read(useState(false), 2), initialValuesLoaded = _2[0], setInitialValuesLoaded = _2[1];
    var _3 = __read(useState(), 2), currentValues = _3[0], setCurrentValues = _3[1];
    var _4 = __read(useState(), 2), eventList = _4[0], setEventList = _4[1];
    var _5 = __read(useState(null), 2), calValue = _5[0], onCalChange = _5[1];
    var _6 = __read(useState(null), 2), minDate = _6[0], setMinDate = _6[1];
    var _7 = __read(useState(null), 2), defaultStartDate = _7[0], setDefaultStartDate = _7[1];
    var _8 = __read(useState(null), 2), defaultEndDate = _8[0], setDefaultEndDate = _8[1];
    var _9 = __read(useState(), 2), savedTypeCode = _9[0], setSavedTypeCode = _9[1];
    var _10 = __read(useState(), 2), evtNum = _10[0], setEvtNum = _10[1];
    var client = useTypedSelector(function (store) { return store.clients; }).client;
    var _11 = useTypedSelector(function (store) { return store.utilities; }), localization = _11.localization, utilitiesStatus = _11.utilitiesStatus;
    var event = useTypedSelector(function (store) { return store.events; }).event;
    var _12 = useRouteMatch().params, clientKey = _12.clientKey, urlKey = _12.urlKey, urlDate = _12.date, eventNumber = _12.eventNumber;
    var location = useLocation();
    var history = useHistory();
    var dispatch = useDispatch();
    var search = useLocation().search.toLowerCase();
    var access = (_b = new URLSearchParams(search).get("access")) !== null && _b !== void 0 ? _b : "";
    var promo = (_c = new URLSearchParams(search).get("promo")) !== null && _c !== void 0 ? _c : "";
    var typeCode = (_e = (_d = new URLSearchParams(search).get("typecode")) !== null && _d !== void 0 ? _d : savedTypeCode) !== null && _e !== void 0 ? _e : "";
    var rawParamGroupId = new URLSearchParams(search).get("group");
    var paramsGroupId = (rawParamGroupId !== null && rawParamGroupId !== void 0 ? rawParamGroupId : "") === "00000000-0000-0000-0000-000000000000" ? undefined : rawParamGroupId !== null && rawParamGroupId !== void 0 ? rawParamGroupId : "";
    // Set payment cookie depending on path
    useSpecificBFPayment();
    var analytics = useWidgetAnalytics();
    var scrollPoint = useRef(null);
    var gaSessions = useContext(WidgetContext).gaSessions;
    useEffect(function () {
        var _a, _b;
        var params = {};
        var parsed = qs.parse(location.search.toLowerCase());
        params = pick(parsed, ["category", "search", "startsat", "endsat"]);
        var initialValuesFromParams = __assign({ category: params.category, search: params.search }, { dateRange: { startsat: (_a = params["startsat"]) !== null && _a !== void 0 ? _a : null, endsat: (_b = params["endsat"]) !== null && _b !== void 0 ? _b : null } });
        setInitialValues(initialValuesFromParams);
        setInitialValuesLoaded(true);
        setEvtNum(eventNumber);
    }, [location]);
    useEffect(function () {
        if (promo) {
            var localPromo = getLocal(LOCAL_STORAGE_KEYS.PROMO);
            if (promo !== "" && localPromo !== promo) {
                setLocal("".concat(LOCAL_STORAGE_KEYS.PROMO), promo, 60 * 60 * 24);
            }
        }
    }, [promo]);
    useEffect(function () {
        if (access) {
            if (access !== "") {
                setLocal("".concat(LOCAL_STORAGE_KEYS.ACCESS), access, 60 * 60 * 24);
            }
        }
    }, [access]);
    useEffect(function () {
        if (typeCode !== savedTypeCode) {
            setSavedTypeCode(typeCode);
        }
    }, [typeCode]);
    var dateData = useMemo(function () {
        var dateObject = {};
        eventList === null || eventList === void 0 ? void 0 : eventList.forEach(function (evt, index) {
            evt.dates.forEach(function (date) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                var localDate = (_b = (_a = date.startsAt) === null || _a === void 0 ? void 0 : _a.local) !== null && _b !== void 0 ? _b : "";
                if (localDate && localDate.split("T")[0]) {
                    if (!dateObject[localDate.split("T")[0]]) {
                        dateObject[localDate.split("T")[0]] = [];
                    }
                    // Group events by common name when they are not multidate or all day
                    var isAllDay = moment((_e = (_d = (_c = evt.dates) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.startsAt) === null || _e === void 0 ? void 0 : _e.local).isSame(moment((_h = (_g = (_f = evt.dates) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.startsAt) === null || _h === void 0 ? void 0 : _h.local).startOf("day"));
                    var isMultiDay = evt.dates.some(function (date) {
                        var _a;
                        return moment(date.startsAt.local).format("YYYY-MM-DD") !==
                            moment((_a = evt.dates[0]) === null || _a === void 0 ? void 0 : _a.startsAt.local).format("YYYY-MM-DD");
                    });
                    var relatedEventNumber = 0;
                    var relatedEvent = dateObject[localDate.split("T")[0]].find(function (e) { return e.title === evt.title && !e.isMultiDay; });
                    if (relatedEvent && !isMultiDay) {
                        relatedEventNumber = relatedEvent.eventNumber;
                    }
                    dateObject[localDate.split("T")[0]].push({
                        title: evt.title,
                        subtitle: evt.subtitle,
                        eventNumber: evt.eventNumber,
                        dateInfo: evt.dateInfo,
                        dateInfoList: evt.dateInfoList,
                        startsAtDate: (_m = (_l = (_k = (_j = evt.dates) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.startsAt) === null || _l === void 0 ? void 0 : _l.local) !== null && _m !== void 0 ? _m : "",
                        hasStickyInfo: !!evt.stickyInfo,
                        hasAdvertisedPrice: evt.lowestAdvertisedPrice !== null,
                        advertisedPrice: evt.lowestAdvertisedPrice,
                        isSoldOut: evt.spotsRemaining !== null && evt.spotsRemaining <= 0,
                        verbiage: evt.verbiage,
                        isAllDay: isAllDay,
                        isMultiDay: isMultiDay,
                        urlKey: evt.urlKey,
                        stickyInfo: evt.stickyInfo,
                        relatedEventNumber: relatedEventNumber,
                        remaining: evt.showRemaining && evt.spotsRemaining !== null && evt.spotsRemaining > 0
                            ? evt.remainingText
                            : undefined,
                        isTimeSlot: evt.isTimeSlot,
                    });
                }
            });
        });
        return dateObject;
    }, [eventList]);
    var setBoundingDatesForOngoingEvents = function () {
        var today = moment().toDate();
        onCalChange(today);
        setDefaultStartDate(today);
        setMinDate(today);
        setDefaultEndDate(moment()
            .add(1, "year")
            .toDate());
    };
    useEffect(function () {
        var _a, _b;
        if (!calValue && !!dateData && !!eventList) {
            if (Object.keys(dateData).length > 0) {
                var sortedDates = Object.keys(dateData)
                    .map(function (d) { return moment(d); })
                    .filter(function (d) { return d.isSameOrAfter(moment().startOf("day")); })
                    .sort(function (a, b) { return (a < b ? -1 : 1); });
                if (sortedDates.length === 0) {
                    setBoundingDatesForOngoingEvents();
                }
                else {
                    var firstFutureEventDate = sortedDates[0];
                    var startDate = (_a = sortedDates[0]) !== null && _a !== void 0 ? _a : moment();
                    var endDate = (_b = sortedDates.pop()) !== null && _b !== void 0 ? _b : moment();
                    var uDate = urlDate ? moment(urlDate) : moment();
                    if (uDate.isBefore(startDate) || endDate.isBefore(uDate)) {
                        onCalChange(firstFutureEventDate.toDate());
                    }
                    else {
                        onCalChange(uDate.toDate());
                    }
                    var firstEvent = moment(firstFutureEventDate).startOf("day");
                    if (urlDate && uDate.isBetween(startDate, endDate)) {
                        setDefaultStartDate(uDate.toDate());
                    }
                    else {
                        setDefaultStartDate(firstEvent.toDate());
                    }
                    setMinDate(moment()
                        .startOf("day")
                        .toDate());
                    setDefaultEndDate(moment(endDate)
                        .endOf("day")
                        .toDate());
                }
            }
            else {
                setBoundingDatesForOngoingEvents();
            }
        }
    }, [dateData, calValue]);
    useEffect(function () {
        if (calValue) {
            var cDate = calValue;
            var foundEvents = dateData[moment(calValue).format("YYYY-MM-DD")];
            if (foundEvents && evtNum && moment(cDate).format("YYYY-MM-DD") !== urlDate) {
                history.replace(Constants.Routes.calendar
                    .replace(":clientKey", clientKey)
                    .replace("/:urlKey?", urlKey ? "/".concat(urlKey) : "")
                    //This is actually always just a Date and not a range, but this package isn't typed for that
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    .replace(":date?", moment(cDate).format("YYYY-MM-DD"))
                    .replace("/:eventNumber?", foundEvents.length === 1 ? "/".concat(foundEvents[0].eventNumber) : "")
                    .replace("/:sharedCapacityId?", ""));
            }
            else if (foundEvents && !evtNum) {
                history.replace(Constants.Routes.calendar
                    .replace(":clientKey", clientKey)
                    .replace("/:urlKey?", urlKey ? "/".concat(urlKey) : "")
                    //This is actually always just a Date and not a range, but this package isn't typed for that
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    .replace(":date?", moment(cDate).format("YYYY-MM-DD"))
                    .replace("/:eventNumber?", foundEvents.length === 1 ? "/".concat(foundEvents[0].eventNumber) : "")
                    .replace("/:sharedCapacityId?", ""));
            }
        }
    }, [calValue]);
    var fetchData = function (clientKey, urlKey, search, startsat, endsat, category) {
        if (clientKey) {
            setIsFetchingCalendar(true);
            getEventList(clientKey, urlKey, search, startsat ? moment(startsat).toISOString() : undefined, endsat
                ? moment(endsat)
                    .add(1, "day")
                    .subtract(1, "second")
                    .toISOString()
                : undefined, category, eventNumber)
                .then(function (_a) {
                var data = _a.data;
                setHeadScripts(data.customHeadCodes.concat(data.cartStackTrackings));
                setBodyScripts(data.customBodyCodes);
                var parsed = qs.parse(window.location.search.toLowerCase());
                var stringified = qs.stringify(__assign(__assign({}, parsed), { search: search, startsat: startsat !== null && startsat !== void 0 ? startsat : undefined, endsat: endsat !== null && endsat !== void 0 ? endsat : undefined, category: category !== null && category !== void 0 ? category : undefined }));
                history.push({ search: stringified });
                setEventList(data.events);
                var eventGoogleAnalyticsProperties = [];
                data.googleTrackings.forEach(function (googleTracking) {
                    if (googleTracking.toUpperCase().startsWith("UA-")) {
                        eventGoogleAnalyticsProperties.push({
                            number: googleTracking,
                            domain: "",
                        });
                    }
                    else if (googleTracking.toUpperCase().startsWith("[{")) {
                        var trackings = JSON.parse(googleTracking);
                        trackings.forEach(function (tracking) {
                            if (!eventGoogleAnalyticsProperties.find(function (g) { return g.number === tracking.number; })) {
                                eventGoogleAnalyticsProperties.push(tracking);
                            }
                        });
                    }
                });
                analytics.setGoogleProperties(eventGoogleAnalyticsProperties);
                eventGoogleAnalyticsProperties.forEach(function (googleProperty) {
                    var domains = googleProperty.domain.split(",");
                    if (!domains.includes(window.widgetHost)) {
                        domains.push(window.widgetHost);
                    }
                    if (gaSessions[googleProperty.number]) {
                        if (window.brushfireDebugMode === "true" || window.brushfireDebugMode === true) {
                            console.log("Connecting to Google Analytics session with client id \"".concat(gaSessions[googleProperty.number].clientId, "\" and session id \"").concat(gaSessions[googleProperty.number].sessionId, "\""));
                        }
                        gtag("config", googleProperty.number, {
                            groups: "CalendarProperties",
                            send_page_view: false,
                            linker: googleProperty.domain !== ""
                                ? {
                                    domains: domains,
                                }
                                : undefined,
                            client_id: gaSessions[googleProperty.number].clientId,
                            session_id: gaSessions[googleProperty.number].sessionId,
                        });
                    }
                    else {
                        gtag("config", googleProperty.number, {
                            groups: "CalendarProperties",
                            send_page_view: false,
                            linker: googleProperty.domain !== ""
                                ? {
                                    domains: domains,
                                }
                                : undefined,
                        });
                    }
                });
                gtag("event", "page_view", { send_to: "CalendarProperties" });
                var eventFacebookIds = [];
                data.facebookTrackings.forEach(function (facebookTracking) {
                    var trackings = facebookTracking.split("|");
                    trackings.forEach(function (tracking) {
                        if (!eventFacebookIds.includes(tracking)) {
                            eventFacebookIds.push(tracking);
                        }
                    });
                });
                if (eventFacebookIds.length) {
                    analytics.setFacebookIds(eventFacebookIds);
                }
                analytics.logPageview();
            })
                .catch(function (err) {
                var _a, _b;
                handleErrors(err, dispatch, undefined, undefined, true);
                if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                    dispatch(setInlineError({ getCalendar: err.response.data.message }));
                }
            })
                .finally(function () {
                setIsFetchingCalendar(false);
                setIsLoaded(true);
            });
        }
    };
    var debounceLoadData = useCallback(debounce(fetchData, 1000), []);
    var assessedValues = initialValues
        ? {
            search: (_g = (_f = currentValues === null || currentValues === void 0 ? void 0 : currentValues.search) !== null && _f !== void 0 ? _f : initialValues === null || initialValues === void 0 ? void 0 : initialValues.search) !== null && _g !== void 0 ? _g : undefined,
            dateRange: {
                startsat: (_l = (_j = (_h = currentValues === null || currentValues === void 0 ? void 0 : currentValues.dateRange) === null || _h === void 0 ? void 0 : _h.startsat) !== null && _j !== void 0 ? _j : (_k = initialValues === null || initialValues === void 0 ? void 0 : initialValues.dateRange) === null || _k === void 0 ? void 0 : _k.startsat) !== null && _l !== void 0 ? _l : undefined,
                endsat: (_q = (_o = (_m = currentValues === null || currentValues === void 0 ? void 0 : currentValues.dateRange) === null || _m === void 0 ? void 0 : _m.endsat) !== null && _o !== void 0 ? _o : (_p = initialValues === null || initialValues === void 0 ? void 0 : initialValues.dateRange) === null || _p === void 0 ? void 0 : _p.endsat) !== null && _q !== void 0 ? _q : undefined,
            },
            category: (_s = (_r = currentValues === null || currentValues === void 0 ? void 0 : currentValues.category) !== null && _r !== void 0 ? _r : initialValues === null || initialValues === void 0 ? void 0 : initialValues.category) !== null && _s !== void 0 ? _s : undefined,
        }
        : undefined;
    useEffect(function () {
        var _a, _b;
        if (initialValuesLoaded) {
            debounceLoadData(clientKey, urlKey, assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.search, (_a = assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.dateRange) === null || _a === void 0 ? void 0 : _a.startsat, (_b = assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.dateRange) === null || _b === void 0 ? void 0 : _b.endsat, assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.category);
        }
    }, [
        initialValuesLoaded,
        clientKey,
        urlKey,
        assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.search,
        (_t = assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.dateRange) === null || _t === void 0 ? void 0 : _t.startsat,
        (_u = assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.dateRange) === null || _u === void 0 ? void 0 : _u.endsat,
        assessedValues === null || assessedValues === void 0 ? void 0 : assessedValues.category,
    ]);
    useEffect(function () {
        var scriptsAdded = [];
        if (headScripts) {
            headScripts.forEach(function (customHeadCode) {
                var dom = new DOMParser().parseFromString(customHeadCode, "text/html");
                var scripts = dom.documentElement.querySelectorAll("script");
                scripts.forEach(function (el) {
                    if (el === null || el === void 0 ? void 0 : el.src) {
                        var script = document.createElement("script");
                        if (el.hasAttributes()) {
                            for (var i = 0; i < el.attributes.length; i++) {
                                var attr = el.attributes[i];
                                script.setAttribute(attr.name, attr.value);
                            }
                        }
                        document.head.appendChild(script);
                    }
                    else {
                        if (el.textContent) {
                            try {
                                eval(el.textContent);
                            }
                            catch (e) {
                                console.error("Error executing the following script:");
                                console.error(el.textContent);
                            }
                        }
                    }
                });
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [headScripts]);
    useEffect(function () {
        var scriptsAdded = [];
        if (bodyScripts) {
            bodyScripts.forEach(function (customBodyCode) {
                var dom = new DOMParser().parseFromString(customBodyCode, "text/html");
                var scripts = dom.documentElement.querySelectorAll("script");
                scripts.forEach(function (el) {
                    if (el === null || el === void 0 ? void 0 : el.src) {
                        var script = document.createElement("script");
                        if (el.hasAttributes()) {
                            for (var i = 0; i < el.attributes.length; i++) {
                                var attr = el.attributes[i];
                                script.setAttribute(attr.name, attr.value);
                            }
                        }
                        scriptsAdded.push(script);
                        document.body.appendChild(script);
                    }
                    else {
                        if (el.textContent) {
                            try {
                                eval(el.textContent);
                            }
                            catch (e) {
                                console.error("Error executing the following script:");
                                console.error(el.textContent);
                            }
                        }
                    }
                });
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [bodyScripts]);
    if (!initialValues ||
        !isLoaded ||
        utilitiesStatus.isLoading ||
        !calValue ||
        !defaultStartDate ||
        !defaultEndDate ||
        !minDate) {
        return (_jsx(Loader, { customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader" }));
    }
    return (_jsx("div", __assign({ className: "page-body tss-calendar-view ta-left ".concat(isWidget ? "widget" : "") }, { children: _jsx(UtilitiesContext.Provider, __assign({ value: { localization: localization } }, { children: _jsx(IntlProvider, __assign({ locale: (_v = client === null || client === void 0 ? void 0 : client.culture) !== null && _v !== void 0 ? _v : "en-US" }, { children: _jsx(Well, __assign({ className: "".concat(isWidget ? "" : "m-bottom-x-large", " tss-calendar-view-page-well well-lg mt-0-sm border-radius-sm-0 ").concat(!!event && event.eventNumber.toString() === eventNumber ? "register-well" : "") }, { children: _jsx("div", __assign({ className: "flex-1 d-flex" }, { children: _jsxs("div", __assign({ className: "d-inline-flex flex-column w-100" }, { children: [_jsxs("div", __assign({ className: "flex-1 m-bottom" }, { children: [_jsx(InlineError, { id: "getCalendar" }), _jsxs(Row, { children: [_jsx(Col, __assign({ md: 5 }, { children: _jsx(Calendar, { onChange: function (val) {
                                                            var _a;
                                                            (_a = scrollPoint.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                                                                behavior: "smooth",
                                                                block: "start",
                                                            });
                                                            onCalChange(val);
                                                            setEvtNum(undefined);
                                                        }, value: calValue, defaultValue: calValue, defaultActiveStartDate: defaultStartDate, locale: (_w = client === null || client === void 0 ? void 0 : client.culture) !== null && _w !== void 0 ? _w : "en-US", tileContent: function (_a) {
                                                            var activeStartDate = _a.activeStartDate, date = _a.date, view = _a.view;
                                                            if (view === "month") {
                                                                if (differenceInCalendarDays(date, new Date()) < 0) {
                                                                    return null;
                                                                }
                                                            }
                                                            var events = dateData[moment(date).format("YYYY-MM-DD")];
                                                            if (!events) {
                                                                return null;
                                                            }
                                                            var lowestPrice = events.reduce(function (accum, curr) {
                                                                return curr.advertisedPrice && curr.advertisedPrice < accum
                                                                    ? curr.advertisedPrice
                                                                    : accum;
                                                            }, 999999999);
                                                            return (_jsx(CalendarDate, { events: events, lowestPrice: lowestPrice, view: view }));
                                                        }, prevLabel: _jsx(Icon, { icon: "chevron-left", type: "solid" }), prev2Label: null, next2Label: null, nextLabel: _jsx(Icon, { icon: "chevron-right", type: "solid" }), minDetail: "month", tileDisabled: function (_a) {
                                                            var date = _a.date, view = _a.view;
                                                            // Disable tiles in month view only
                                                            var events = dateData[moment(date).format("YYYY-MM-DD")];
                                                            if (view === "month") {
                                                                if (!events) {
                                                                    return true;
                                                                }
                                                                else if (events && events.every(function (evt) { return evt.isSoldOut; })) {
                                                                    return true;
                                                                }
                                                                // Check if a date React-Calendar wants to check is on the list of disabled dates
                                                                return differenceInCalendarDays(date, new Date()) < 0;
                                                                //return disabledDates.find(dDate => isSameDay(dDate, date));
                                                            }
                                                            return false;
                                                        }, tileClassName: function (_a) {
                                                            var date = _a.date, view = _a.view, activeStartDate = _a.activeStartDate;
                                                            // Disable tiles in month view only
                                                            var classes = [];
                                                            if (view === "month") {
                                                                // Check if a date React-Calendar wants to check is on the list of disabled dates
                                                                if (differenceInCalendarDays(date, new Date()) < 0) {
                                                                    var events = dateData[moment(date).format("YYYY-MM-DD")];
                                                                    if (events) {
                                                                        classes.push("past-date-with-events");
                                                                    }
                                                                    else {
                                                                        classes.push("past-date");
                                                                    }
                                                                }
                                                                if ("".concat(activeStartDate.getFullYear()).concat(activeStartDate.getMonth()) !==
                                                                    "".concat(date.getFullYear()).concat(date.getMonth())) {
                                                                    classes.push("neighbor-month");
                                                                }
                                                                //return disabledDates.find(dDate => isSameDay(dDate, date));
                                                            }
                                                            return classes;
                                                        }, minDate: minDate, maxDate: defaultEndDate, showFixedNumberOfWeeks: true }) })), _jsxs(Col, __assign({ md: 7, className: "calendar-right" }, { children: [_jsx("div", { ref: scrollPoint, id: "calendar-events-top" }), calValue && (_jsx(_Fragment, { children: _jsx(CalendarEvents, { calValue: calValue, dateData: dateData, typeCode: typeCode, paramsGroupId: paramsGroupId }) }))] }))] })] })), _jsx(FadeSection, __assign({ fade: !!event && event.eventNumber.toString() === eventNumber, className: "sticky-footer" }, { children: _jsx(RegisterFooter, { eventData: event, isLoading: false, cartTotalSeen: true, path: Constants.Routes.calendar }) }))] })) })) })) })) })) })));
};
export default CalendarView;
